// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"5ebef558","453":"319408c2","700":"2232376a"}[chunkId] + ".chunk.js";
};